import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  Subject,
  Observable,
  catchError,
  EMPTY,
} from 'rxjs';
import { API_URL } from '../utils';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  private http = inject(HttpClient);
  apiUrl = inject(API_URL);

  readonly httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Cache-Control':
        'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
      Pragma: 'no-cache',
      Expires: '0',
    }),
  };
  private stopPolling = new Subject<void>();
  readonly allNotifications: any[] = [];

  private fetchNotifications(userId: number): Observable<any[]> {
    return this.getNotificationsByUserId(userId);
  }

  getNotificationsByUserId(userId: number): Observable<any[]> {
    return this.http
      .get<any[]>(`${this.apiUrl}unread/${userId}`, this.httpOptions)
      .pipe(
        catchError((error) => {
          console.error(error);
          return EMPTY;
        })
      );
  }

  markAsRead(notificationId: string[]): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http
      .post<any>(`${this.apiUrl}notifications/read/`, notificationId, { headers })
      .pipe(
        catchError((error) => {
          console.error('Error:', error);
          throw error;
        })
      );
  }

  stopPollingForNotifications(): void {
    this.stopPolling.next();
    this.stopPolling.complete();
  }
}
